import React from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Button, CircularProgress, useTheme, Typography } from '@mui/material';
import { Save as SaveIcon, Send as SendIcon } from '@mui/icons-material';

const SubmissionActionButtons = ({ onSaveAndQuit, onSubmit, submission, disabled, isSubmitting }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isResubmit = (submission?.submitToReviewCount || 0) >= 1;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'sticky',
        bottom: 16,
        bgcolor: theme.palette.background.paper,
        borderRadius: 2,
        p: 2,
        border: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2,
        flexWrap: 'wrap',
      }}>
      <Button variant="outlined" startIcon={<SaveIcon />} onClick={onSaveAndQuit} disabled={isSubmitting}>
        <Typography variant="h3">{t('submission.saveAndQuit')}</Typography>
      </Button>

      <Button
        variant="contained"
        color="primary"
        startIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : <SendIcon />}
        onClick={onSubmit}
        disabled={disabled}>
        <Typography variant="h3">
          {isResubmit ? t('submission.resubmitForReview') : t('submission.submitForReview')}
        </Typography>
      </Button>
    </Paper>
  );
};

export default SubmissionActionButtons;
